import { render, staticRenderFns } from "./CustomerManagement.vue?vue&type=template&id=2c74196a&scoped=true"
import script from "./CustomerManagement.vue?vue&type=script&lang=js"
export * from "./CustomerManagement.vue?vue&type=script&lang=js"
import style0 from "./CustomerManagement.vue?vue&type=style&index=0&id=2c74196a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c74196a",
  null
  
)

export default component.exports